import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { api } from '@/api';

/**
 * Registro de acesso: cada página aberta e cada clique em botão, aba, link ou item de menu vai para a API
 * (em lotes, a cada poucos segundos e ao sair da página). O professor vê tudo na aba "Acessos".
 */
interface Evento {
  tipo: 'pagina' | 'clique';
  alvo: string;
  pagina: string;
  quando: string;
}

let fila: Evento[] = [];
let enviando = false;

async function envia(keepalive = false) {
  if (enviando || !fila.length) return;
  const lote = fila;
  fila = [];
  enviando = true;
  try {
    await api.post('/eventos', { eventos: lote }, { keepalive, timeoutMs: 8_000 });
  } catch {
    fila = [...lote, ...fila].slice(-200); // tenta de novo no próximo ciclo
  } finally {
    enviando = false;
  }
}

function registra(tipo: Evento['tipo'], alvo: string) {
  fila.push({
    tipo,
    alvo: alvo.slice(0, 200),
    pagina: window.location.pathname,
    quando: new Date().toISOString(),
  });
  if (fila.length >= 20) void envia();
}

const CLICAVEIS =
  'button, a, [role="tab"], [role="option"], [role="menuitem"], [role="slider"], [data-rastro]';

function rotulo(el: Element): string {
  const explicito = el.getAttribute('data-rastro') || el.getAttribute('aria-label');
  const texto = (el.textContent ?? '').replace(/\s+/g, ' ').trim();
  const href = el.getAttribute('href');
  const base = explicito || texto || el.getAttribute('title') || el.tagName.toLowerCase();
  return href && !href.startsWith('javascript') ? `${base} → ${href}` : base;
}

export function Rastro() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    registra('pagina', pathname + search);
  }, [pathname, search]);

  useEffect(() => {
    const aoClicar = (e: MouseEvent) => {
      const el = (e.target as Element | null)?.closest?.(CLICAVEIS);
      if (el) registra('clique', rotulo(el).slice(0, 120));
    };
    const aoEsconder = () => {
      if (document.visibilityState === 'hidden') void envia(true);
    };
    const timer = window.setInterval(() => void envia(), 5_000);
    document.addEventListener('click', aoClicar, true);
    document.addEventListener('visibilitychange', aoEsconder);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener('click', aoClicar, true);
      document.removeEventListener('visibilitychange', aoEsconder);
      void envia(true);
    };
  }, []);

  return null;
}
